import axios from "axios";

const BASE_URL =
    process.env.REACT_APP_API_URL;

export const getAllOrders = async (
    page,
    size,
    token
) => {
    try {

        const response = await axios.get(
            `${BASE_URL}/food/api/orders/getall/${page}/${size}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );

        return response.data;

    } catch (error) {

        console.error("GET Orders Error:", error);

        throw error;
    }
};

// In your Servicefile/ordermanagementservice.jsx
// In your Servicefile/ordermanagementservice.jsx
export const getOrderById = async (orderId, token) => {
    try {
        const response = await axios.get(
            `${BASE_URL}/food/api/orders/order/${orderId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching order by ID:", error);
        throw error;
    }
};
export const getLedgerRangeData = async (
    fromDate,
    toDate,
    token
) => {
    try {

        const response = await axios.get(
            `${BASE_URL}/food/api/ledger/company-restaurant/range?fromDate=${fromDate}&toDate=${toDate}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );

        return response.data;

    } catch (error) {

        console.error("GET Ledger Data Error:", error);

        throw error;
    }
};

export const getCateringOrders =
    async (token) => {

        try {

            const response =
                await axios.get(
                    `${BASE_URL}/catering/api/admin/all`,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`,
                            Accept: "*/*",
                        },
                    }
                );

            return response.data;

        } catch (error) {

            console.error(
                "GET Catering Orders Error:",
                error
            );

            throw error;
        }
    };

// ==============================
// GET CATERING VENDORS
// ==============================

export const getCateringVendors =
    async (token) => {

        try {

            const response =
                await axios.get(
                    `${BASE_URL}/catering/api/admin/get/all`,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`,
                            Accept: "*/*",
                        },
                    }
                );

            return response.data;

        } catch (error) {

            console.error(
                "GET Catering Vendors Error:",
                error
            );

            throw error;
        }
    };

// ==============================
// DEBUG ADMIN API
// ==============================

export const debugAdminApi =
    async (token) => {

        try {

            const response =
                await axios.get(
                    `${BASE_URL}/catering/api/admin/all`,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`,
                            Accept: "*/*",
                        },
                    }
                );

            return response;

        } catch (error) {

            console.error(
                "DEBUG Admin API Error:",
                error
            );

            throw error;
        }
    };
export const approveCateringOrder = async (
    orderId,
    bodyData,
    token
) => {
    try {

        const response = await axios.put(
            `${BASE_URL}/catering/api/admin/approval/${orderId}`,
            bodyData,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response.data;

    } catch (error) {

        console.error("APPROVE Catering Order Error:", error);

        throw error;
    }
};
export const fetchAllOrders = async () => {
    const authToken = localStorage.getItem("authToken");

    if (!authToken) {
        throw new Error("No auth token found. Please login.");
    }

    const response = await fetch(
        `${BASE_URL}/catering/api/admin/all`,
        {
            headers: {
                Authorization: `Bearer ${authToken}`,
                Accept: "*/*",
            },
        }
    );

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
};

export const getAllDeliveryOrders =
    async (token) => {

        try {

            const response =
                await axios.get(
                    `${BASE_URL}/delivery/api/admin/get/all/offers`,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`,
                            "Content-Type":
                                "application/json",
                        },
                    }
                );

            return response.data;

        } catch (error) {

            console.error(
                "GET Delivery Orders Error:",
                error
            );

            throw error;
        }
    };

// ==============================
// GET DELIVERY ORDER BY ID
// ==============================

export const getDeliveryOrderById =
    async (orderId, token) => {

        try {

            const response =
                await axios.get(
                    `${BASE_URL}/delivery/api/admin/get/offer/by/id?id=${orderId}`,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`,
                            "Content-Type":
                                "application/json",
                        }
                    }
                );

            return response.data;

        } catch (error) {

            console.error(
                "GET Delivery Order By ID Error:",
                error
            );

            throw error;
        }
    };


export const getAllVendorOrders = async (token) => {
    try {

        const response = await axios.get(
            `${BASE_URL}/orders/getall/vendors`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "*/*"
                }
            }
        );

        return response.data;

    } catch (error) {

        console.error(
            "Get Vendor Orders Error:",
            error
        );

        throw error;
    }
};

// 1. Fetch SINGLE Food Order by ID
// ==============================
// FETCH SINGLE FOOD ORDER BY ID (NEW DEDICATED API)
// ==============================
export const getFoodOrderById = async (orderId, token) => {
    try {
        const response = await axios.get(
            `${BASE_URL}/food/api/orders/order/${orderId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );

        // This API returns the exact single order object directly
        return response.data;

    } catch (error) {
        console.error("GET Order By ID Error:", error);
        throw error;
    }
};

// 2. Fetch DELIVERY Order details (Rider info, etc.)
export const getDeliveryOrderDetails = async (orderId, appType, token) => {
    try {
        const response = await axios.get(
            `${BASE_URL}/delivery/api/get/order`,
            {
                params: {
                    orderId: orderId,
                    appType: appType
                },
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("GET Delivery Order Details Error:", error);
        throw error; // We will catch this and treat it as "Not a delivery order"
    }
};